// extracted by css-extract-rspack-plugin
export default {"title-wrapper":"CampaignModeration-module__title-wrapper--LITjr","titleWrapper":"CampaignModeration-module__title-wrapper--LITjr"};